<template>
    <!-- split subelementLayoutModel between LayoutModel and Composable
        Reassemble in location.vue
        Assign reassembled model to bind-->
    <location-sub-element-layout
        v-bind="subElementLayoutModel"
        ref="LocationSubElementLayout"
        v-on:update="sendLocationDataChange"
        v-on:map-initialize-failed="onInitializeFailed"
        v-on:reinitialize-map="reinitializeMap"
        v-on:accept-manual-override="acceptManualOverride"
        v-on:cancel-manual-override="cancelManualOverride"
        v-on:open-manual-override="openManualOverride"
        v-on:longitude-wrapper="longitudeSetter"
        v-on:latitude-wrapper="latitudeSetter"
        v-on:override-longitude-wrapper="overrideLongitudeSetter"
        v-on:override-latitude-wrapper="overrideLatitudeSetter"
        v-on:overlay-geocode-from-dependency="overlayGeocodeFromDependency"
        v-on:geocode-from-dependency="geocodeFromDependency"
        v-on:validated="onLocationValidated"
        v-on:update-has-location-validation-errors="updateHasLocationValidationErrors"
        v-on:help-clicked="$emit('help-clicked')">
        <template v-slot:help>
            <slot name="help" />
        </template>
    </location-sub-element-layout>
</template>

<script>
    import base from "./_elementBase";
    import { useStore } from "vuex";
    import { useLocationShared } from "./locationSubElement";
    import LocationSubElementLayout from "./locationSubElementLayout.vue";
    import { AUX_MUTATION } from "Forms/Components/ProjectForm/projectFormStore";

    // extend base logic
    export default {
        components: { LocationSubElementLayout },
        extends: base,
        emits: ["help-clicked"],
        setup(props) {
            return {
                ...useLocationShared(useStore(), props.element, props.element.DataFieldId, props.isInFormEditor)
            };
        },
        data() {
            return {
                hasLocationValidationErrors: false
            };
        },
        computed: {
            subElementLayoutModel() {
                return {
                    ...this.locationDataModel,
                    label: this.label,
                    required: this.required,
                    showHelp: this.showHelp,
                    showHelpLinkOnly: this.showHelpLinkOnly,
                    readonly: this.readonly,
                    isInFormEditor: this.isInFormEditor,
                    element: this.element
                };
            }
        },
        created() {
            this.initializeMap();
        },
        methods: {
            async initializeMap() {
                // initializeMapConfig is implemented in locationSubElement.js
                await this.initializeMapConfig();
                if (this.$refs && this.$refs.LocationSubElementLayout) {
                    this.$refs.LocationSubElementLayout.initializeMapControl(this.locationDataModel.mapConfig);
                }
            },
            async reinitializeMap() {
                // reinitializeMapConfig is implemented in locationSubElement.js
                await this.reinitializeMapConfig();
                if (this.$refs && this.$refs.LocationSubElementLayout) {
                    this.$refs.LocationSubElementLayout.reinitializeMapControl();
                    await this.$nextTick();
                    this.$refs.LocationSubElementLayout.reSizeMapControl();
                }
            },
            updateHasLocationValidationErrors(value) {
                this.hasLocationValidationErrors = value;
                this.$store.commit(AUX_MUTATION, {
                    elementId: this.element.PublicId,
                    auxState: { hasLocationValidationErrors: value }
                });
            }
        }
    };
</script>
